import type { BadgeProps} from '@chakra-ui/react'
import { Badge, forwardRef } from '@chakra-ui/react'

export interface RoundBadgeProps extends BadgeProps {}

export const RoundBadge = forwardRef(
  ({ children, sx, ...rest }: RoundBadgeProps, ref) => {
    return (
      <Badge
        ref={ref}
        variant="solid"
        bg="badge-bg"
        sx={{
          display: 'grid',
          w: 7,
          h: 7,
          placeItems: 'center',
          ...sx,
        }}
        {...rest}
      >
        {children}
      </Badge>
    )
  },
)
